module.exports = __webpack_public_path__ + "static/media/paypal.c30dff7e.png";